import { render } from "./CapitalAccountList.vue?vue&type=template&id=ec609d38&scoped=true"
import script from "./CapitalAccountList.vue?vue&type=script&lang=js"
export * from "./CapitalAccountList.vue?vue&type=script&lang=js"

import "./CapitalAccountList.vue?vue&type=style&index=0&id=ec609d38&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec609d38"]])

export default __exports__